import styled, { css } from 'styled-components';
import { Box } from 'modules/Box';
import { pxToRem } from 'modules/spacing';
import { theme } from 'modules/tetrisTheme';
const disabledStyles = css `
  background-color: transparent;

  & * > * {
    color: ${theme.swatches.warm[500]};
  }
`;
const selectedStyles = css `
  background-color: ${theme.semantic.surface.sunken};

  &:hover {
    background-color: ${theme.semantic.surface.sunken};
  }

  > [data-icon='falcon'] {
    color: ${theme.semantic.foreground.primary};
  }
`;
export const ListItemContainerInner = styled.div.attrs((props) => (Object.assign(Object.assign({}, props), { as: props.onClick ? 'button' : props.as }))) `
  display: flex;
  flex-grow: 1;
  min-width: 0;
  align-items: center;
  justify-content: flex-start;
  gap: ${theme.spacing.md};
  padding: ${theme.spacing.md};
  text-align: left;

  &:is(button, a):not(:disabled, [disabled]) {
    cursor: pointer;
  }

  ${({ disabled }) => disabled && disabledStyles};
  ${({ $selected, disabled }) => $selected && !disabled && selectedStyles};
`;
export const ListItemContainer = styled.div `
  display: flex;
  flex-shrink: 0;
  align-items: center;
  width: 100%;
  user-select: none;
  border: none;
  outline: ${theme.spacing.sm} solid transparent;
  background-color: ${theme.semantic.surface.primary};
  border-radius: ${theme.borderRadius.md};
  text-align: left;
  color: ${theme.semantic.foreground.primary};
  font-size: ${theme.fontSize.medium};
  font-weight: ${theme.fontWeight.regular};
  text-decoration: none;
  line-height: 1;
  transition-duration: 0.2s;
  transition-property: border, background-color, outline;
  transition-timing-function: ease-out;

  /* Only apply hover styles to clickable/tabbable elements */
  &:hover:not(:disabled, [disabled]):has([role='button'], button, a, label) {
    background-color: ${theme.semantic.surface.sunken};

    ${ListItemContainerInner} > [data-icon='falcon'] {
      color: ${theme.semantic.foreground.primary};
    }
  }

  &:focus-visible {
    box-shadow: 0 0 0 ${pxToRem(2)} ${theme.semantic.focus.ring};
  }

  &:active:not(:disabled, [disabled]):is([role='button'], button, a, label) {
    background-color: ${theme.swatches.warm[200]};
  }

  ${ListItemContainerInner} > [data-icon='falcon'] {
    width: ${pxToRem(16)};
    height: ${pxToRem(16)};
    color: ${theme.swatches.warm[500]};
  }

  ${({ $selected, disabled }) => $selected && !disabled && selectedStyles};
`;
export const List = styled.section `
  display: flex;
  flex-direction: column;
  background-color: ${theme.semantic.surface.primary};
  gap: ${theme.spacing.sm};
`;
export const ListItemDivider = styled.hr `
  flex-shrink: 0;
  border: none;
  margin: ${theme.spacing.xs} ${theme.spacing.md};
  height: ${pxToRem(1)};
  background-color: color-mix(in srgb, ${theme.swatches.warm[100]}, transparent 50%);
`;
export const StickyHeaderContainer = styled(Box) `
  position: ${(props) => (props.$sticky ? 'sticky' : 'relative')};
  top: 0;
  z-index: ${(props) => (props.$sticky ? '2' : '1')};
  background-color: ${theme.semantic.surface.primary};
`;
export const HeaderActions = styled.div `
  margin-left: auto;
`;
export const StickyFooterContainer = styled(Box) `
  position: ${(props) => (props.$sticky ? 'sticky' : 'relative')};
  bottom: 0;
  background-color: ${theme.semantic.surface.primary};
`;
export const ListItemActions = styled.div `
  display: flex;
  overflow: hidden;
  margin-left: auto;
  margin-right: ${theme.spacing.md};
  flex-shrink: 0;
`;
